import styles from "@/styles/productReviews/product-detail.module.scss";
import { useState, useEffect } from "react";
import { Skeleton } from 'antd';
import productApi from "@/service/modules/productApi";
import Link from "next/link";

interface Props {
  productId: string;
  courierID: number;
  productUrl: string;
}
export default function ReviewProductDetail({ productId, courierID, productUrl }: Props) {
  const [featuresHtml, setfeaturesHtml] = useState("");
  const [specificationHtml, setspecificationHtml] = useState("");
  const [loadingDetailData, setLoadingDetailData] = useState(false);
  const tableRegex = /<table[^>]+>/g;

  const upDateTable = (richText: string) => {
    if (!richText) {
      return "";
    }
    return richText.replace(/style=/g, "").replace(tableRegex, (match) => {
      return match.replace(">", " style='width: 100% !important;'>");
    });
  };

  const getDetail = async () => {
    try {
      const res = await productApi.getDescription(productId);
      const { description } = res.data;
      if (description) {
        const { features, product, specification } = description;
        const newTabs = [];
        if (product || courierID == 11) {
          newTabs.push({
            // key: 'goods-detail',
            key: "description-box",
            label: "Description",
          });
        }
        if (features) {
          newTabs.push({
            key: "features-box",
            label: "Features",
          });
        }
        if (specification) {
          newTabs.push({
            key: "specification-box",
            label: "Specification",
          });
        }
        const html = `<p style="font-weight:bold;margin-top:8px;"><br/>This item is an authentic parallel-import and items will be shipped from our supplier's warehouse and may take 2 to 3 days processing after payment confirmation. Parcel will be sent out by <b>DHL / UPS Courier Service</b> and may take 3 to 7 working days for delivery.<br/>If this product requires a charger, An New Zealand Certified Charger will be provided with this product instead of the original charger.(*Selected product only)</p>`;
        let newDescriptionHtml = product ? product.content : "";
        if (courierID == 11) {
          newDescriptionHtml = newDescriptionHtml + html;
        }
        features && setfeaturesHtml(features.content);
        specification &&
          setspecificationHtml(upDateTable(specification.content));

        // features, product, specification, warranty以外的属性
        const blackList = ["features", "product", "specification", "warranty"];
        const customList = [];
        for (const key in description) {
          if (
            Object.prototype.hasOwnProperty.call(description, key) &&
            blackList.indexOf(key) == -1
          ) {
            const element = description[key];
            newTabs.push({
              key: element.title,
              label: element.title,
            });
            customList.push({
              name: element.title,
              html: element.content,
            });
          }
        }
      }
      setLoadingDetailData(true)
    } catch (error: any) {
      setLoadingDetailData(true)
      console.log(error);
    }
  };

  useEffect(() => {
    if (productId) getDetail();
  }, [productId]);

  return (
    <div className={styles["review-detail-product-detail"]}>
      {featuresHtml && (
        <div className={styles["features-box"]} id="features-box">
          <div className={styles["title"]}>Features:</div>
          <div dangerouslySetInnerHTML={{ __html: featuresHtml }}></div>
        </div>
      )}

      {specificationHtml && (
        <div className={styles["specification-box"]} id="specification-box">
          <div className={styles["title"]}>Specification:</div>
          <div
            style={{ overflow: "hidden" }}
            dangerouslySetInnerHTML={{ __html: specificationHtml }}
          ></div>
        </div>
      )}

      {
        !loadingDetailData && (
          <Skeleton style={{ padding: '24px 0' }} active />
        )
      }
      
      {
        !!(loadingDetailData && !featuresHtml && !specificationHtml) && (
          <Link
            href={`${productUrl}`}
            legacyBehavior
          >
            <a className={styles['no-data']} rel="noopener noreferrer">
              Click to view more product details.
            </a>
          </Link>
        )
      }
    </div>
  );
}
